/*
 * @Author: zxf
 * @Date: 2021-11-19 17:57:50
 * @LastEditors: zhangqi
 * @LastEditTime: 2024-12-18 11:38:46
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\snap\SnapController.js
 */

import Controller from '../clazz/Controller';
import { Utils } from '../utils';
export class SnapController extends Controller{
	/**
     * 捕捉控制器类初始化方法.
     * @param {undefined}
     * @returns {undefined}
     */
	constructor(options) {
        super(options);
        this.viewer = options.viewer;
        /**
         * 捕捉器集合
         * @type {Object|null}
         */
        this.snapActors = [];
        /**
         * 当前捕捉对象对应的捕捉行为对象
         * @type {Object|null} activeSnapActor
         */
        this.activeSnapActor = null;
        /**
         * 捕捉控制器是否运行的标志
         * @type {Boolean} isRunning
         */
        this.isRunning = false;
        /**
         * 捕捉点的容差范围
         * @type {Number} tolerance
         */
        this.tolerance = 20;
        /**
         * 重复捕捉下当前捕捉要素
         * @type {Number} currSnap
         */
        this.currSnap = null;

        /**
         * 捕捉结果可能是多个
         * @type {Array} snapResult
         */
         this.snapResult = [];

        /**
         * 捕捉点
         * @type {Object|null} snapPoint
         */
        this.snapPoint = null;
        /**
         * 绑定事件事件
         * 
         */
        this.viewer.renderArea.addEventListener('keyup', this.onKeydown.bind(this));
    }

    /**
     * 添加tab切换事件.
     * @param {Object} snapResult - 捕捉行为对象
     * @return {undefined}
     */
     onKeydown(e) {
        if(this.snapResult && this.snapResult.length > 1 && e.ctrlKey && e.key == 'q') {
            let currindex = -1;
            for (let index = 0; index < this.snapResult.length; index++) {
                const element = this.snapResult[index];
                if(element.feature.id === this.currSnap.feature.id) {
                    currindex = index;
                }
            }
            if (currindex == this.snapResult.length - 1) {
                this.currSnap = this.snapResult[0];
            } else {
                this.currSnap = this.snapResult[currindex + 1];
            }
            this.drawSnapActor(this.activeSnapActor, this.snapResult, this.snapPoint);
        }
     }

    /**
     * 向捕捉控制器的捕捉行为容器中添加新的捕捉行为对象.
     * @param {Object} snapActor - 捕捉行为对象
     * @return {undefined}
     */
    add(snapActor) {
        for (let i = 0; i < this.snapActors.length; ++i) {
            if (snapActor === this.snapActors[i]) {
                return;
            }
        }

        // snapActor.setMap(this.map.getLeafletMap());
        this.snapActors.push(snapActor);

        this.snapActors = this.snapActors.sort((a, b) => b.priority - a.priority);
    }

    /**
     * 从捕捉控制器的捕捉行为容器中删除给定的捕捉行为对象
     * 并更新捕捉反馈.
     * @param {Object} snapActor - 捕捉行为对象
     * @return {undefined}
     */
    del(snapActor) {
        for (let i = 0; i < this.snapActors.length; ++i) {
            if (snapActor === this.snapActors[i]) {
                snapActor.shutdown();
                this.snapActors.splice(i, 1);
                return;
            }
        }
    }

    /**
     * 从捕捉控制器的捕捉行为容器中删清除所有的的捕捉行为对象
     * 并更新捕捉反馈.
     * @return {undefined}
     */
    clear() {
        for (let i = 0; i < this.snapActors.length; ++i) {
            const snapActor = this.snapActors[i];
            snapActor.shutdown();
        }

        this.snapActors = [];
    }

    /**
     * 启动捕捉控制器，开启捕捉行为
     * 一般在工具启动时调用.
     * @return {undefined}
     */
    startup() {
        for (let i = 0; i < this.snapActors.length; ++i) {
            const snapActor = this.snapActors[i];
            snapActor.startup();
        }
        this.isRunning = true;
    }

    /**
     * 关闭捕捉控制器，停止捕捉行为
     * 一般在工具停止时调用.
     * @return {undefined}
     */
    shutdown() {
        for (let i = 0; i < this.snapActors.length; ++i) {
            const snapActor = this.snapActors[i];
            snapActor.shutdown();
        }
        this.isRunning = false;
    }

    /**
     * 判断捕捉控制器是否开启捕捉状态.
     * @returns {boolean} isRunning
     */
    isSnapping() {
        return this.isRunning;
    }

    /**
     * 根据移动鼠标所在的点位进行对应捕捉行为下数据或者是要素的捕捉.
     * @param {Object} point - geoJson点几何对象
     * @returns {Object} snapResult - 捕捉结果
     */
    snap(point) {
        this.snapPoint = point;
        if (!this.isRunning) {
            return null;
        }

        if (this.snapActors.length === 0) {
            return null;
        }

        if (this.activeSnapActor) {
            this.activeSnapActor.clear();
            this.activeSnapActor = null;
        }

        let snapResult = null;
        let tmpSnapResult = null;

        for (let i = 0; i < this.snapActors.length; ++i) {
            const snapActor = this.snapActors[i];

            // 捕捉器的捕捉方案，优先判断优先级，优先级相等的情况下，再按照距离的远近进行优先捕捉
            if (this.activeSnapActor && snapActor.priority < this.activeSnapActor.priority) {
                break;
            }
            tmpSnapResult = snapActor.snap(point);
            if (!tmpSnapResult) {
                continue;
            } else {
                this.activeSnapActor = snapActor;
                if(Array.isArray(tmpSnapResult)) {
                    snapResult = tmpSnapResult;
                } else {
                    snapResult = [tmpSnapResult];
                }
            }
        }

        // 无点云区域转换
        if(!(snapResult && snapResult.length) && ~this.snapActors.findIndex(i => i.type === 'SnapPointCloud')) {
            snapResult = [{
                snapPoint : Utils.getWorldCoordinate(this.viewer.renderArea,this.viewer.scene, point.x, point.y, point.z)
            }];
        }

        if(snapResult && snapResult.length >= 1) {
            this.setCurrSnap(snapResult);
        }
        // 这里绘制捕捉十字效果
        if (this.activeSnapActor && snapResult) {
            this.drawSnapActor(this.activeSnapActor, snapResult, point);
        }

        this.snapResult = snapResult;
        return snapResult;
    }

    getCurrSnap() {
        return this.currSnap;
    }

    setCurrSnap(snap) {
        if(!this.isSame(snap)) {
            this.currSnap = snap[0];
        } else {
            this.currSnap = snap.filter(item => item.feature.id === this.currSnap.feature.id)[0];
        }
    }

    isSame(snaps) {
        if(snaps.length <= 1 || !this.snapResult) {
            return false;
        } else if(snaps.length != this.snapResult.length) {
            return false;
        } else if(snaps[0].type == 'snapFeature' && this.snapResult[0].type == 'snapFeature') { // 差分比较
            let status = [];
            snaps.forEach(element => {
                let eleStatus = false;
                this.snapResult.forEach(item => {
                    if(element.feature.id == item.feature.id) {
                        eleStatus = true;
                    }
                })
                status.push(eleStatus);
            });
            if(status.filter(ele => !ele).length > 0) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }

    /**
     * 获取捕捉查找数据的范围.
     * @param {Object} point - geoJson点几何对象
     * @param {Number} tolerance - 鼠标点的捕捉范围，单位为像素
     * @returns {Object} geojson - 返回查找数据的面范围geoJson对象
     */
    getBox(point, tolerance) {
        const x = point.coordinates[0];
        const y = point.coordinates[1];
        const zoom = this.map.getZoom();
        const pixelPoint = this.mercator.geographic2Pixel(x, y, zoom);
        const left = pixelPoint[0] - tolerance;
        const right = pixelPoint[0] + tolerance;
        const top = pixelPoint[1] - tolerance;
        const bottom = pixelPoint[1] + tolerance;

        const coordinates = [];
        const leftTop = this.mercator.pixel2Geographic(left, top, zoom);
        const rightTop = this.mercator.pixel2Geographic(right, top, zoom);
        const rightBottom = this.mercator.pixel2Geographic(right, bottom, zoom);
        const leftBottom = this.mercator.pixel2Geographic(left, bottom, zoom);

        coordinates.push(leftTop);
        coordinates.push(rightTop);
        coordinates.push(rightBottom);
        coordinates.push(leftBottom);
        coordinates.push(leftTop);

        const geojson = {
            type: 'Polygon',
            coordinates: [coordinates],
        };

        return geojson;
    }

    /**
     * 获取当前捕捉到的要素对应的捕捉行为对象.
     * @return {Object} activeSnapActor - 捕捉行为对象
     */
    getActiveSnapActor() {
        return this.activeSnapActor;
    }

    /**
     * 调用捕捉器绘制方法绘制捕捉反馈
     * @return {undefined}
     */
    drawSnapActor(snapActor, snapResult, mousePoint) {
        if (!this.isRunning) {
            return;
        }

        snapActor.draw(snapResult, mousePoint);
    }

}